"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JointLifeNewYorkInfo = JointLifeNewYorkInfo;
exports.JointLifeNonNewYorkInfo = JointLifeNonNewYorkInfo;
exports.SingleLifeNewYorkInfo = SingleLifeNewYorkInfo;
exports.SingleLifeNonNewYorkInfo = SingleLifeNonNewYorkInfo;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CommonTableHeader() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 1,
    id: "ageRangeHeader",
    className: "ageRangeLabelSticky"
  }, "Age range"), /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 11,
    id: "withdrawalRatesHeader",
    className: "withdrawalRatesLabelSticky"
  }, /*#__PURE__*/_react.default.createElement("div", null, "Withdrawal rate"))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    colSpan: 1,
    id: "ageColHeaderBlankCell",
    className: "ageColSticky"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "ZeroYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "0 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "FirstYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "1 yr")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "SecondYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "2 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "ThirdYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "3 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "FourthYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "4 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "FifthYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "5 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "SixthYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "6 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "SeventhYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "7 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "EighthYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "8 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "NinthYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "9 yrs")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "TenthYearHeader"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "10+ yrs")))));
}
function SingleLifeNonNewYorkInfo() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "retirepay-info-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, {
    tableCaption: "GLWB Single Life Non-New York Info Table"
  }, /*#__PURE__*/_react.default.createElement(CommonTableHeader, null), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange59To61"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "59.5 - 61"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "4.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "4.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "5.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "5.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "5.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "5.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "6.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "6.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "6.65%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange62To66"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "62 - 66"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "5.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "5.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "5.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "6.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "6.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "6.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "7.15%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange67To71"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "67 - 71"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "5.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "6.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "6.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "6.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "7.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "7.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "7.65%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange72To76"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "72 - 76"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "6.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "6.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "6.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "6.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "7.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "7.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "7.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "7.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "8.15%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange77Over"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "77+"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "6.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "6.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "7.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "7.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "7.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "7.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "7.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "8.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "8.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "8.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "8.65%"))))));
}
function SingleLifeNewYorkInfo() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "retirepay-info-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, {
    tableCaption: "GLWB Single Life New York Info Table"
  }, /*#__PURE__*/_react.default.createElement(CommonTableHeader, null), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange59To61"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "59.5 - 61"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "4.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "4.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "4.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "4.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "5.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "5.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "5.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "5.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "6.20%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange62To66"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "62 - 66"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "4.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "5.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "5.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "5.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "6.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "6.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "6.85%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange67To71"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "67 - 71"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "5.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "5.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "6.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "6.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "6.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "7.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "7.50%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange72To76"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "72 - 76"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "6.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "6.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "6.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "6.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "7.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "7.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "7.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "7.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "8.15%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange77To81"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "77 - 81"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "6.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "7.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "7.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "7.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "7.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "7.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "8.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "8.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "8.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "8.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "8.80%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange82To86"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "82 - 86"), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: 2
  }), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "8.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "8.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "9.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "9.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "9.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "9.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "9.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "10.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "10.20%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange87To91"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "87 - 91"), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: 7
  }), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "11.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "11.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "11.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "11.60%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange92Over"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "92+"), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: 10
  }), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "13.00%"))))));
}
function JointLifeNonNewYorkInfo() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "retirepay-info-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, {
    tableCaption: "GLWB Joint Life Non-New York Info Table"
  }, /*#__PURE__*/_react.default.createElement(CommonTableHeader, null), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange59To61"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "59.5 - 61"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "4.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "4.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "4.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "4.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "4.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "5.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "5.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "5.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "5.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "5.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "6.10%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange62To66"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "62 - 66"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "4.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "4.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "5.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "5.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "5.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "5.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "6.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "6.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "6.60%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange67To71"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "67 - 71"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "5.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "5.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "5.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "6.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "6.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "6.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "7.10%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange72To76"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "72 - 76"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "5.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "6.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "6.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "6.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "7.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "7.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "7.60%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange77Over"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "77+"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "6.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "6.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "6.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "6.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "7.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "7.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "7.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "7.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "8.10%"))))));
}
function JointLifeNewYorkInfo() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "retirepay-info-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, {
    tableCaption: "GLWB Joint Life New York Info Table"
  }, /*#__PURE__*/_react.default.createElement(CommonTableHeader, null), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange59To61"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "59.5 - 61"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "3.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "3.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "4.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "4.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "4.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "4.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "4.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "5.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "5.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "5.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "5.65%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange62To66"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "62 - 66"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "4.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "4.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "4.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "4.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "5.30%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "5.50%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "5.70%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "5.90%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "6.30%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange67To71"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "67 - 71"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "4.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "5.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "5.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "5.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "5.95%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.15%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "6.35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "6.55%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "6.75%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "6.95%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange72To76"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "72 - 76"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "5.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "5.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "6.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "6.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "6.60%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "6.80%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "7.00%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.20%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "7.40%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "7.60%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange77To81"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "77 - 81"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ZeroYearRate"
  }, "6.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FirstYearRate"
  }, "6.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "6.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "6.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "7.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "7.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "7.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "7.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "7.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "8.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "8.25%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange82To86"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "82 - 86"), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: 2
  }), /*#__PURE__*/_react.default.createElement("td", {
    id: "SecondYearRate"
  }, "8.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "ThirdYearRate"
  }, "8.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FourthYearRate"
  }, "8.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "FifthYearRate"
  }, "8.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SixthYearRate"
  }, "8.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "9.05%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "9.25%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "9.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "9.65%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange87To91"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "87 - 91"), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: 7
  }), /*#__PURE__*/_react.default.createElement("td", {
    id: "SeventhYearRate"
  }, "10.45%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "EighthYearRate"
  }, "10.65%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "NinthYearRate"
  }, "10.85%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "11.05%")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "AgeRange92Over"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "AgeRange"
  }, "92+"), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: 10
  }), /*#__PURE__*/_react.default.createElement("td", {
    id: "TenthYearRate"
  }, "12.45%"))))));
}